import { useNavigate } from '@tanstack/react-router';
import type { UseFormSetError } from 'react-hook-form';
import { isConflictError, resolveApiErrorMessage } from '@/utils/errors';
import { UserForm } from '../components/UserForm';
import { useCreateUser } from '../hooks/useCreateUser';
import { USER_CATEGORY_ROUTES, type UserTypeGroup } from '../constants/user.constants';
import type { CreateUserPayload } from '../types/user.types';

const USERNAME_TAKEN_MESSAGE = 'This username is already in use';

function withoutEmptyEmail(values: CreateUserPayload): CreateUserPayload {
  return { ...values, email: values.email || undefined };
}

interface UserCreatePageProps {
  category: UserTypeGroup;
}

export function UserCreatePage({ category }: UserCreatePageProps) {
  const navigate = useNavigate();
  const backRoute = USER_CATEGORY_ROUTES[category];
  const { mutate, isPending } = useCreateUser(() => {
    void navigate({ to: backRoute });
  });

  function handleSubmit(
    values: CreateUserPayload,
    setFieldError: UseFormSetError<CreateUserPayload>,
  ) {
    mutate(withoutEmptyEmail(values), {
      onError: (error) => {
        if (!isConflictError(error)) return;
        setFieldError(
          'username',
          { message: resolveApiErrorMessage(error, USERNAME_TAKEN_MESSAGE) },
          { shouldFocus: true },
        );
      },
    });
  }

  return (
    <UserForm
      category={category}
      onSubmit={handleSubmit}
      isPending={isPending}
      onCancel={() => navigate({ to: backRoute })}
    />
  );
}
